import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface ConfirmActivateCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
}

export function ConfirmActivateCampaignDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: ConfirmActivateCampaignDialogProps) {
  const [isActivating, setIsActivating] = useState(false);

  const handleConfirm = async () => {
    setIsActivating(true);
    try {
      await onConfirm();
      // Dialog será fechado pelo parent após sucesso
    } catch (error) {
      // Erro será tratado pelo parent (toast)
    } finally {
      setIsActivating(false);
    }
  };

  const loading = isLoading || isActivating;

  return (
    <Dialog open={open} onOpenChange={loading ? undefined : onOpenChange}>
      <DialogContent className="sm:max-w-[500px]" onPointerDownOutside={loading ? (e) => e.preventDefault() : undefined}>
        <DialogHeader>
          <DialogTitle>Ativar campanha?</DialogTitle>
          <DialogDescription className="pt-2 space-y-2">
            Ao ativar, o template do questionário será congelado e um link público será gerado para coleta de respostas.
            <br />
            <br />
            Você poderá encerrar a campanha a qualquer momento para gerar o resultado oficial.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {loading ? "Ativando..." : "Ativar campanha"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
